export const Endpoints = {
    GET_SAL_FORMAT: "/nis/station/induct/sal/format/get",
    GET_INDUCT_LOCATIONS: "/nis/station/induct/locations/get",
    POST_INDUCT_PACKAGE: "/nis/package/induct"
};


// WEBPACK FOOTER //
// ./src/components/utils/network/Enpoints.js